import React from "react";
import DatePickerField from "../admin/DatePickerField";
import TimePickerField from "../admin/TimePickerField";
import { DEADLINE_HOURS, DEADLINE_MINUTES, DEFAULT_DEADLINE_TIME } from "../../lib/portalKinds";

/**
 * A deadline, picked the platform's way: the same calendar and time columns
 * as a group's sessions, instead of the browser's own control. The value is
 * `{date: "YYYY-MM-DD", time: "HH:MM"}` on Romania's clock; `fromDeadlineParts`
 * turns it into the moment the server stores.
 *
 * Choosing a day without a time sets 23:59 — "by Tuesday" means by the end of it.
 */
export default function DeadlineField({ value, onChange, testid = "portal-deadline" }) {
  const { date = "", time = "" } = value || {};
  return (
    <div className="grid grid-cols-[minmax(0,1fr)_8.5rem] gap-2">
      <DatePickerField
        value={date}
        ariaLabel="Ziua termenului"
        testid={`${testid}-date`}
        onChange={(d) => onChange({ date: d, time: d ? time || DEFAULT_DEADLINE_TIME : "" })}
      />
      <TimePickerField
        size="md"
        value={date ? time : ""}
        ariaLabel="Ora termenului"
        testid={`${testid}-time`}
        hours={DEADLINE_HOURS}
        minutes={DEADLINE_MINUTES}
        onChange={(t) => onChange({ date, time: t })}
      />
    </div>
  );
}
